import { AccountsTable } from '../components/AccountsTable';

export const AccountsPage = () => {
  return <AccountsTable />;
};
